import { useDeselectOnEmptyClick } from 'hooks/useDeselectOnEmptyClick'
import { CANVAS_ITEM_FRAME_CLASS_NAME } from 'consts'
import {
  CANVAS_CONTAINER_ID,
  POSITIONED_MEDIA_CONTROLS_HOST_CLASS_NAME
} from '../../consts'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { editorSelectors } from 'store/features/editor/selectors'
import { IMediaItem } from 'types/media'
import editorSlice from 'store/features/editor/slice'
import { dispatch } from 'store'

export const useDeselectCanvasItems = () =>
  useDeselectOnEmptyClick(CANVAS_CONTAINER_ID, [
    CANVAS_ITEM_FRAME_CLASS_NAME,
    POSITIONED_MEDIA_CONTROLS_HOST_CLASS_NAME
  ])

// Clear edit state if the item being edited disappears (deleted via
// toolbar, undo, or any other path). No engine restore is needed because
// the engine object is gone with the item.
export const useClearTextEditState = (mediaItems: IMediaItem[]) => {
  const editingTextId = useSelector(editorSelectors.editingTextId)

  useEffect(() => {
    if (!editingTextId) return
    const stillExists = mediaItems.some(m => m.id === editingTextId)
    if (!stillExists) {
      dispatch(editorSlice.actions.setEditingTextId(null))
    }
  }, [editingTextId, mediaItems])
}
